"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getCellData = exports.prop = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ui_common_1 = require("@codametrix/ui-common");
var classnames_1 = __importDefault(require("classnames"));
var prop = function (caseRun, propName, optDefault) {
    if (optDefault === void 0) { optDefault = 'N/A'; }
    if (caseRun === null || caseRun === undefined) {
        return optDefault;
    }
    return ui_common_1.objectUtils.get(caseRun, propName, optDefault) || optDefault;
};
exports.prop = prop;
/**
 * Function to format cell data with optional capitalization.
 * @function
 * @param {string} data - The input data to be formatted.
 * @param {boolean} shouldCapitalize - Flag indicating whether to capitalize the data.
 * @returns {React.ReactNode} - The formatted cell data.
 */
var getCellData = function (data, shouldCapitalize, styleClasses) {
    var title;
    if (data === null || data === undefined) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    if (data && (data === null || data === void 0 ? void 0 : data.length) >= 10) {
        title = data;
    }
    if (title) {
        return ((0, jsx_runtime_1.jsx)("span", __assign({ title: title, className: (0, classnames_1["default"])(styleClasses) }, { children: shouldCapitalize ? ui_common_1.objectUtils.capitalize(data) : data })));
    }
    else {
        return ((0, jsx_runtime_1.jsx)("span", __assign({ className: (0, classnames_1["default"])(styleClasses) }, { children: shouldCapitalize ? ui_common_1.objectUtils.capitalize(data) : data })));
    }
};
exports.getCellData = getCellData;
//# sourceMappingURL=related-cases.utilities.js.map